// LemmaCategoryType.js
import LocalStorageUtil from './user/LocalStorageUtil';

//must use 'all' in one of a dict 
  export const LemmaCategoriesTypes = {
    'topk':{
    "element-school": [
      "all","1k", "2k", "3k", "4k", "5k"
    ],
    "intermediate": [
      "6k", "7k", "8k","9k", "10k"
    ],
    "highschool": [
      "11k", "12k","13k", "14k", "15k", "16k"
    ],
    "post-secondary": [
      "17k", "18k", "19k", "20k",
      "21k", "22k", "23k", "24k", "25k"
    ]
    },
    'chsbk':{
    "element-school": [
    "all","1-1", "1-2", "2-1", "2-2", "3-1", "3-2", "4-1", "4-2", "5-1", "5-2"
    ],
    "intermediate": [
      "6-1", "6-2", "7-1","7-2", "8-1", "8-2"
    ],
    // "highschool": [],
    // "post-secondary": [],
    }
  };

  // Utility: get all categories
  export const getDefaultCategoriesSet = (lctname = 'topk') => ['all', ...Object.keys(LemmaCategoriesTypes[lctname])];
  
  // Utility: get types for a given category
  export const getTypesByCategory = (category,lctname = 'topk') => {
    if (category === 'all') return [];
    return LemmaCategoriesTypes[lctname][category] || [];
  };
  
  // Utility: find category by type name
  export const findCategoryByType = (value,lctname = 'topk') => {
    //if (value === 'all') return value;
    for (const [key, values] of Object.entries(LemmaCategoriesTypes[lctname])) {
      //console.log('lctname=',lctname,'key=',key,'values=',values,'value=',value); 
      if (values.includes(value)) {
        return key;
      }
    }
    return null;
  };
  
  // Utility: generate first type within each category, with sortOption
  export const  GetCategorysFirstTypeSet = (baseLocalDevUrl, sortOption = 'best-match',path='lemma',lctname = 'topk') => {
    return Object.entries(LemmaCategoriesTypes[lctname]).map(([category, types]) => {
      const firstType = types[0];
      let url = `${baseLocalDevUrl}/${path}/${firstType}?page=1`;
      if (sortOption !== 'best-match') {
        url += `&sort=${sortOption}`;
      }
      return { name: category, url, category };
    });
  };
  
  // Utility: generate nav links for all types under a category,with sortoption
  export const GetCategoryTypesSet = (category, baseLocalDevUrl, para_wordtags,
    sortOption = 'best-match',path='lemma',para_period='day',lctname = 'topk') => {
    if (category === 'all') return [];
    const types = LemmaCategoriesTypes[lctname][category];
    if (!types) return [];
  
    const links = [
      { name: category, url: '#' },
      ...types.map(type => {
        let url = `${baseLocalDevUrl}/${path}/${type}?wordtag=${para_wordtags}&page=1`;
        if (sortOption !== 'best-match') {
          url += `&sort=${sortOption}`;
        }
        if(path==='progress'){
          url += `&period=${para_period}`;
        }
        return { name: type, url, type };
      })
    ];
  
    return links;
  };
  
  // Utility: generate JSX for category/type navigation list
  export const renderCategoryTypesDom = (links, paraType) => {
    return (
      <ul className='spLeftTypes'>
        {links.map((link, index) => (
          <li key={index} className={`spLeftTypeslist ${link.type === paraType ? 'sphighlight' : ''}`}>
            <a className='spLeftTypeslink' href={link.url}>
              {link.name}
            </a>
          </li>
        ))}
      </ul>
    );
  };
  


    const WordTagsCategoriesTypes =  (path='lemma') => {
    const session = LocalStorageUtil.getSession();
    const userTags = session?.usrprofile?.wordtags || [];
  
    // Remove duplicates and preserve order
    const uniqueTags = [...new Set(userTags)];
    return {
      wordtags: (path === 'lemma' || path === 'cmnlemma'|| path === 'cmnbook'|| path === 'frelemma'|| path === 'cmnphrase')
      ? ['all', 'notag', ...uniqueTags]
      : ['all',...uniqueTags]
    };

    // "wordtags": [
    //   "all", "learned", "hard","other"
    // ]
    
  };

  const PeriodsCategoriesTypes =  (path='progress') => {

    return {
      period: 
       ['day', 'week','month']
    };
    
  };
  


    // Utility: find category by type name
    export const getWordTagsCategoryByType = (value,path='lemma') => {
     // if (value === 'all') return value;
      for (const [key, values] of Object.entries(WordTagsCategoriesTypes(path))) {
        if (values.includes(value)) {
          return key;
        }
      }
      return null;
    };
  

    // Utility: find period category by type name
    export const getPeriodsCategoryByType = (value,path='progress') => {
      // if (value === 'all') return value;
       for (const [key, values] of Object.entries(PeriodsCategoriesTypes(path))) {
         if (values.includes(value)) {
           return key;
         }
       }
       return null;
     };
   
    
  // Utility: generate nav links for all types under a category,with sortoption
  export const GetWordTagsCategoryTypesSet = (category, baseLocalDevUrl,para_type, 
    sortOption = 'best-match',path='lemma',para_period='day') => {
    if (category === 'all') return [];
    const types = WordTagsCategoriesTypes(path)[category];
    if (!types) return [];
  
    const links = [
      { name: category, url: '#' },
      ...types.map(type => {
        let url = `${baseLocalDevUrl}/${path}/${para_type}?wordtag=${type}&page=1`;
        if (sortOption !== 'best-match') {
          url += `&sort=${sortOption}`;
        }
        if(path === 'progress'){
          url += `&period=${para_period}`;
        }
        return { name: type, url, type };
      })
    ];
  
    return links;
  };

    // Utility: generate nav links for all types under a category,with sortoption
    export const GetPeriodsCategoryTypesSet = (category, baseLocalDevUrl,para_type, 
      sortOption = 'best-match',path='progress',para_wordtag) => {
      if (category === 'all') return [];
      const periods = PeriodsCategoriesTypes(path)[category];
      if (!periods) return [];
    
      const links = [
        { name: category, url: '#' },
        ...periods.map(period => {
          let url = `${baseLocalDevUrl}/${path}/${para_type}?wordtag=${para_wordtag}&page=1`;
          if (sortOption !== 'best-match') {
            url += `&sort=${sortOption}`;
          }
          if(path === 'progress'){
            url += `&period=${period}`;
          }
          return { name: period, url, type:period };
        })
      ];
    
      return links;
    };

    // Utility: generate JSX for category/type navigation list
    export const renderWordTagsCategoryTypesDom = (links, paraType) => {
      return (
        <ul className='spLeftTypes'>
          {links.map((link, index) => (
            <li key={index} className={`spLeftTypeslist ${link.type === paraType ? 'sphighlight' : ''}`}>
              <a className='spLeftTypeslink' href={link.url}>
                {link.name}
              </a>
            </li>
          ))}
        </ul>
      );
    };

    // Utility: generate JSX for category/type navigation list
    export const renderPeroidsCategoryTypesDom = (links, paraPeriod) => {
      return (
        <ul className='spLeftTypes'>
          {links.map((link, index) => (
            <li key={index} className={`spLeftTypeslist ${link.type === paraPeriod ? 'sphighlight' : ''}`}>
              <a className='spLeftTypeslink' href={link.url}>
                {link.name}
              </a>
            </li>
          ))}
        </ul>
      );
    };
// export default LemmaCategoriesTypes;



